import CaseForm from './CaseForm';

const ViewCaseScreen = props => {
  const {caseData: c, providerId} = props;
  return (
    <CaseForm 
      caseId={c?.id}
      editing={true}
    />
  );
};

export default ViewCaseScreen;